import { render, staticRenderFns } from "./caixa.vue?vue&type=template&id=4897ed74&scoped=true"
import script from "./caixa.vue?vue&type=script&lang=js"
export * from "./caixa.vue?vue&type=script&lang=js"
import style0 from "./caixa.vue?vue&type=style&index=0&id=4897ed74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897ed74",
  null
  
)

export default component.exports